import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/shared/Reveal";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { useLanguage } from "@/context/LanguageContext";
import { CONTENT } from "@/i18n/content";

export function FAQ() {
  const { lang } = useLanguage();
  const t = CONTENT[lang].faq;

  return (
    <section id="faq" className="scroll-mt-20 bg-cream py-20 sm:py-28" data-testid="faq">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <SectionHeading eyebrow={t.eyebrow} title={t.title} />

        <Reveal delay={100} className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {t.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="overflow-hidden rounded-2xl border border-navy/10 bg-white px-5 data-[state=open]:border-gold/40 data-[state=open]:shadow-[0_10px_30px_-16px_rgba(15,27,61,0.2)]"
              >
                <AccordionTrigger className="py-5 text-left font-heading text-base font-semibold text-navy hover:no-underline sm:text-lg">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-navy/70">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
